import { render, staticRenderFns } from "./randomSampling.vue?vue&type=template&id=28c77708&scoped=true&"
import script from "./randomSampling.vue?vue&type=script&lang=js&"
export * from "./randomSampling.vue?vue&type=script&lang=js&"
import style0 from "./randomSampling.vue?vue&type=style&index=0&id=28c77708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c77708",
  null
  
)

export default component.exports